import React, { useEffect, useState, useRef } from "react";
import { Loader, TextInput, createStyles, Box, keyframes } from "@mantine/core";
import { Search } from "tabler-icons-react";
import authAxios from "../../keycloak/authAxios";

const brandColor = "rgb(42, 155, 73)";

const fadeIn = keyframes({
  from: { opacity: 0, transform: "translateY(10px)" },
  to: { opacity: 1, transform: "translateY(0)" },
});

const useStyles = createStyles((theme) => ({
  wrapper: {
    width: "100%",
    animation: `${fadeIn} 0.4s ease`,
  },
  searchInput: {
    ".mantine-TextInput-input": {
      backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.white,
      border: `1px solid ${theme.colorScheme === "dark" ? theme.colors.dark[4] : "#e9ecef"}`,
      borderRadius: theme.radius.lg,
      height: 54,
      paddingRight: 44,
      fontSize: 16,
      transition: "border-color 0.2s ease",
      boxShadow: "none",
      "&:focus": { borderColor: brandColor, boxShadow: "none" },
      "&::placeholder": {
        color: theme.colorScheme === "dark" ? theme.colors.dark[3] : "#adb5bd",
      },
    },
    ".mantine-TextInput-icon": { color: brandColor },
    ".mantine-TextInput-rightSection": { right: "auto", left: 0 },
  },
}));

export const SearchBar = ({ onSearch, flag }) => {
  const { classes } = useStyles();
  const [loading, setLoading] = useState(false);
  const [nameFilter, setNameFilter] = useState("");
  const debounceRef = useRef(null);
  const abortControllerRef = useRef(null);

  useEffect(() => {
    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }

    if (nameFilter === "" && !flag) {
      return;
    }

    setLoading(true);

    debounceRef.current = setTimeout(() => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }

      const controller = new AbortController();
      abortControllerRef.current = controller;

      let API_URL = `arshad?limit=100&order_by=desc`;

      if (flag) {
        API_URL += `&flag=${flag}`;
      }

      if (nameFilter) {
        API_URL += `&full_name=${nameFilter}`;
      }

      authAxios
        .get(API_URL, { signal: controller.signal })
        .then((res) => {
          onSearch(res.data.result);
          setLoading(false);
        })
        .catch((err) => {
          if (err.name !== "CanceledError") {
            setLoading(false);
          }
        });
    }, 500);

    return () => {
      if (debounceRef.current) {
        clearTimeout(debounceRef.current);
      }
    };
  }, [nameFilter, flag]);

  return (
    <Box className={classes.wrapper}>
      <TextInput
        onChange={(e) => setNameFilter(e.target.value)}
        rightSection={loading && <Loader size={22} color={brandColor} variant="dots" />}
        placeholder="ابحث عن الاسم"
        icon={<Search size={20} color={brandColor} />}
        size="md"
        radius="lg"
        className={classes.searchInput}
      />
    </Box>
  );
};
